import React  from 'react'

import { Redirect, useLocation } from 'react-router-dom'

import { Window } from '../contexts/index.jsx'
import { ProductSearchHelper } from "../helpers"
import { Tabs, Title } from "../layouts/Default"
import { ListingList } from "../components"

const getPageTitle = (search) => {
    if (search.list) {
        return {
            favourites: 'Saved Listings',
            wishlist: 'Wishlist',
            new: 'Latest Arrivals',
        }[search.list]
    }

    if (search.filters.category_id) {
        // Window.CATEGORIES is filled by an async fetch (contexts/Window.js) and
        // is [] until it resolves, so .find() can return undefined. Guard the
        // name access — a missing category must fall back to a generic title,
        // never throw during render.
        const category = Window.CATEGORIES.find((c) => c.id === search.filters.category_id)
        const title = category?.name

        if (title) {
            if (Object.keys(search.filters).length > 1 || search.query) {
                return 'Search ' + title
            }

            return title;
        }
    }

    return 'Search Results';
}

const Listings = () => {
    const location = useLocation()
    const search = ProductSearchHelper.parseUrl(location)

    search.sort.field = search.sort?.field || 'refreshed_at';

    if (!search) {
        return <Redirect to="/not-found" />
    }

    const title = getPageTitle(search);
    const tabs = [
        { label: 'Wishlist', link: '/products/wishlist' },
        { label: 'Saved Listings', link: '/products/favourite' },
    ];
    const showTabs = ['favourites', 'wishlist'].includes(search.list);

    return (
        <div className="flex-grow-1">
            {showTabs && <Tabs tabs={tabs} mobile desktop />}
            {!showTabs && <Title>{title}</Title>}
            <main id="results">
                <div className="container mt-3">
                    <ListingList
                        isProduct={search.list === 'wishlist'}
                        {...ProductSearchHelper.prepareForServer(search)}
                    />
                </div>
            </main>
        </div>
    )
}

export default Listings
